// operatory.reducer.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { fetchAllOperatories } from '../actions/operatory.action'
import { IOperatory } from '@dataTypes/appointment.type'

interface OperatoryState {
  data: IOperatory[] | []
  loading: boolean
  error: string | null
}

const initialState: OperatoryState = {
  data: [],
  loading: false,
  error: null,
}

const operatorySlice = createSlice({
  name: 'operatory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Fetch Operatories
    builder.addCase(fetchAllOperatories.pending, (state) => {
      state.loading = true
      state.error = null
    })

    builder.addCase(
      fetchAllOperatories.fulfilled,
      (state, action: PayloadAction<IOperatory[]>) => {
        state.data = action.payload
        state.loading = false
        state.error = null
      },
    )

    builder.addCase(fetchAllOperatories.rejected, (state) => {
      state.loading = false
      state.error = 'Failed to delete appointment'
    })

    // Matcher
    builder.addMatcher(
      (action) =>
        action.type.startsWith('operatory/') &&
        action.type.endsWith('/pending'),
      (state) => {
        state.loading = true
      },
    )
    builder.addMatcher(
      (action) =>
        action.type.startsWith('operatory/') &&
        action.type.endsWith('/rejected'),
      (state) => {
        state.error = 'Failed to process request'
        state.loading = false
      },
    )
  },
})

export default operatorySlice.reducer
